import { useEffect, useState } from "react";

const useDarkMode = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const checkDarkMode = () => {
      const skin = document.documentElement.getAttribute("data-skin");
      setIsDark(skin === "dark");
    };

    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-skin"]
    });

    return () => observer.disconnect();
  }, []);

  return isDark;
};

export default useDarkMode;
